/** The story piece's behavior half: reads the studio and splits its story into paragraphs. Draws nothing. */
import { useMemo } from 'react';

import { useSiteStudio } from '../../api/site';
import { usePieceOptions, type PieceInput, type PieceRuntime } from '../../contract/runtime';
import { contract, type StoryActions, type StoryEvents, type StoryState } from './contract';

export type StoryRuntime = PieceRuntime<typeof contract, StoryState, StoryActions>;

const NO_ACTIONS: StoryActions = {};

export function useStory(input: PieceInput<StoryEvents> = {}): StoryRuntime {
  const options = usePieceOptions(contract, input.options);
  const query = useSiteStudio();
  const story = query.data?.story;

  const paragraphs = useMemo(
    () =>
      (story ?? '')
        .split(/\n\s*\n/)
        .map((p) => p.trim())
        .filter(Boolean),
    [story],
  );
  const status: StoryState['status'] = query.data ? 'ready' : query.isError ? 'error' : 'loading';

  return { state: { status, paragraphs }, actions: NO_ACTIONS, options };
}
